import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { nestedProp } from "../../../utils/nestedProp";
import Text from "../components/Text";
import { devConsoleLog } from "../../../utils/devConsoleLog";
import { ProcessContext } from "../../../contexts/ProcessContext";

import CriticalErrorMessage from "../components/CriticalErrorMessage";
import RetriableErrorMessage from "../components/RetriableErrorMessage";
import { NotificationSnackbar } from "../components/NotificationSnackbar/NotificationSnackbar";
import { ConfigContext } from "../../../contexts/ConfigContext";

export default function NotificationManager() {
  const {
    state: { dictionaryValues },
  } = useContext(ConfigContext);
  const notificationsArray = [
    {
      snackbarNotification: useContext(AuthContext).state.snackbarNotification,
      dispatch: useContext(AuthContext).dispatch,
      updateContextActionName: "UPDATE_AUTH_CONTEXT",
    },
    {
      snackbarNotification:
        useContext(ProcessContext).state.snackbarNotification,
      dispatch: useContext(ProcessContext).dispatch,
      updateContextActionName: "UPDATE_PROCESS_CONTEXT",
    },
  ];

  const initialState = {
    message: null,
    level: null,
    dispatchInContext: null,
    updateContextActionName: null,
  };
  const [state, setState] = useState(initialState);
  const {
    state: { processCriticalError, processRetriableError },
  } = useContext(ProcessContext);

  const processErrorExists = processRetriableError || processCriticalError;

  useEffect(() => {
    if (!state.message || !state.level) {
      notificationsArray.forEach((notificationInContext) => {
        if (
          notificationInContext.snackbarNotification &&
          notificationInContext.snackbarNotification.snackbarInformation
        ) {
          manageExceptionDialog(notificationInContext);
          devConsoleLog("currentNotification", state);
        }
      });
    }
  });

  useEffect(() => {
    if (processRetriableError || processCriticalError) {
      retriableErrorMessageManager();
    }
  }, [processRetriableError, processCriticalError]);

  const getException = (action) => {
    const responseDataException =
      nestedProp(action, "payload.data.exception") ||
      nestedProp(action, "payload.response.data.exception");
    const responseDataError =
      nestedProp(action, "payload.data.error") ||
      nestedProp(action, "payload.response.data.error");
    const errorInfo =
      responseDataException && responseDataError
        ? `${responseDataException} ${responseDataError}`
        : "No response";
    return ` ${action.type}: ${errorInfo}`;
  };
  const closeNotification = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    if (state.message) {
      state.dispatchInContext({
        type: state.updateContextActionName,
        payload: {
          snackbarNotification: {
            snackbarInformation: null,
            level: "info",
          },
        },
      });
      setState({ ...state, message: null });
    }
  };

  const retriableErrorMessageManager = () => {
    const retriableErrorMessage = processRetriableError?.type && (
      <Text tId={`ACTION_${processRetriableError.type}`} />
    );
    setState((s) => ({ ...s, retriableErrorMessage: retriableErrorMessage }));
  };

  const getDefaultMessageByLevel = (level) => {
    switch (level) {
      case "error":
        return <Text tId={"ACTION_GENERIC_ERROR"} />;
      case "info":
        return <Text tId={"ACTION_GENERIC_INFO"} />;
      case "success":
        return <Text tId={"ACTION_GENERIC_SUCCESS"} />;
      case "warning":
        return <Text tId={"ACTION_GENERIC_WARNING"} />;
      default:
        return <Text tId={"DEFAULT_MESSAGE"} />;
    }
  };

  const manageExceptionDialog = (notificationInContext) => {
    const snackbarNotification = notificationInContext.snackbarNotification;
    const dispatchInContext = notificationInContext.dispatch;
    const snackbarInformation =
      snackbarNotification && snackbarNotification.snackbarInformation;
    const updateContextActionName =
      notificationInContext.updateContextActionName;
    const level = snackbarNotification && snackbarNotification.level;
    let msg = <Text tId={""} />;
    let exception = "";
    const msgTextId =
      snackbarInformation.type && `ACTION_${snackbarInformation.type}`;
    let errorObject = {};
    msg = dictionaryValues[msgTextId] ? (
      <Text tId={msgTextId} />
    ) : (
      getDefaultMessageByLevel(level)
    );

    if (level === "error") {
      exception = getException(snackbarInformation);
      errorObject = snackbarInformation.payload;
    }
    const autoHide = level !== "error";
    setState({
      ...state,
      message: msg,
      errorObject,
      exception,
      level,
      autoHide,
      dispatchInContext,
      updateContextActionName,
    });
  };
  const {
    message,
    autoHide,
    level,
    retriableErrorMessage,
    exception,
    errorObject,
  } = state;
  // TODO CHECK CONSOLE WARNING findDOMNode... PRODUCED BY SNACKBAR. DEPENDENCIES MAYBE?
  return processErrorExists ? (
    <>
      {processCriticalError && (
        <CriticalErrorMessage message={message} action={processCriticalError} />
      )}
      {processRetriableError && (
        <RetriableErrorMessage
          message={retriableErrorMessage}
          action={processRetriableError}
        />
      )}
    </>
  ) : (
    <NotificationSnackbar
      open={message !== null}
      autoHide={autoHide}
      onClose={closeNotification}
      errorObject={errorObject}
      message={message}
      exception={exception}
      onClick={state.autoHide && closeNotification}
      level={level}
    />
  );
}
